<span class="body-1-semi-bold text" [style.opacity]="loading ? 0 : 1">
  <ng-content></ng-content>
</span>

<div class="loading-button-overlay" *ngIf="loading">
  <svg-icon [name]="'progress-bar'" [style.color]="loadingIconColor" class="spinning-el" style="width: 24px; height: 24px"></svg-icon>
</div>
